var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLongLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 204.874,
    height: 54.011,
    viewBox: "0 0 204.874 54.011",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-2{fill:#4e4e4e}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49424",
    transform: "translate(-857.999 -224.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    fill: "#9d270d",
    d: "M130.748 195.89h-4.314l12.335-19.166-13.763-19.968h4.406l11.488 16.663 10.724-16.662h4.314l-12.807 19.9 13.257 19.235h-4.406L141 179.961z",
    transform: "translate(877.793 81.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19",
    d: "M0 0H3.627V39.133H0z",
    className: "cls-2",
    transform: "translate(1059.246 238.583)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    d: "M103.072 157.933l3.452-.015 5.925-9.2-3.452.015z",
    className: "cls-2",
    transform: "translate(859.961 75.296)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    d: "M113.463 196.167v-3.343a16.348 16.348 0 1 1 16.6-19.235h-16.6v2.9h20.2a19.69 19.69 0 1 0-20.2 19.683z",
    className: "cls-2",
    transform: "translate(852.814 81.856)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    d: "M71.016 161.353l1.265-3.093a19.691 19.691 0 1 0 0 36.449q-.634-1.547-1.265-3.095a16.348 16.348 0 1 1 0-30.261z",
    className: "cls-2",
    transform: "translate(812.864 81.856)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    d: "M74.38 195.89h16.214v-3.628H78.008v-35.505H74.38z",
    className: "cls-2",
    transform: "translate(836.638 81.826)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongLogo);
export default __webpack_public_path__ + "static/media/long-logo.f0b07a2cccd66ef1199d2a3bc1045c41.svg";
export { ForwardRef as ReactComponent };